import React, { useContext } from 'react';

/* packages */
import Fetch from '../../../util-fetch';
/* packages */

/* stores */
import ListStore from './store';
/* stores */

const Index = ({CONFIG, token}) => {
  const companyListContext  = useContext(ListStore);
  const companyListMethod = async () => {
    companyListContext.setLoading(true);
    CONFIG.application.company.api.headers.Authorization = token;
    const fetch = await Fetch({
      url: CONFIG.application.company.api.endpoints.list.url,
      config: {
        method: CONFIG.application.company.api.endpoints.list.method,
        headers: CONFIG.application.company.api.headers
      }
    });
    companyListContext.setStatus(fetch[0]);
    companyListContext.setData(fetch[1]);
    companyListContext.setLoading(false);
  }
  const companyListData = companyListContext.isData();

  return { companyListContext, companyListMethod, companyListData }
}

export default Index;
